import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { enableMocking } from '@tests/mocks/enable-mocking';

import { App } from '@/App';
import '@/common/styles/global.css';
import '@/infra/observability/analytics/init';
import '@/infra/observability/clarity/init';
import '@/infra/observability/sentry/init';

const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('O elemento root não foi encontrado');
}

enableMocking().then(() => {
  if (!rootElement.innerHTML) {
    const root = createRoot(rootElement);

    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }
});
